import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';

import { ContentType } from '@/content/types/content.types';
import { COURSE_MODE } from '@/courses/enums/course-edition.enum';
import { EdSectionOptions } from '@/content/models/ed-section-options.model';
import { Section } from '@/courses/models/section.model';
import { FixedSection } from '@/sections/types/sections.types';

@Component({
  name: 'ed-content-sidebar-section',
  components: {
    EdContentSectionControls: () => import(/* EdContetnSectionControls */'@/courses/components/ed-content-section-controls/ed-content-section-controls.component.vue'),
  }
})
export default class EdContentSidebarSectionComponent extends Vue {

  @Prop({ default: null }) readonly contentId: number;
  @Prop({ default: null }) readonly classId: number;
  @Prop({ default: '' }) readonly componentName: string;
  @Prop({ default: '' }) readonly label: string;
  @Prop({ default: false }) readonly hasLessonCounter: boolean;
  @Prop({ default: COURSE_MODE.VIEWER }) readonly mode: COURSE_MODE;
  @Prop({ default: false }) readonly loading: boolean;
  @Prop({ default: false }) readonly loaded: boolean;
  @Prop({ default: false }) readonly isEmpty: boolean;
  @Prop({ default: 0 }) readonly lessonCounter: number;
  @Prop({ default: () => [] }) readonly menuAddOptions: any[];
  @Prop({ default: () => [] }) readonly sections: Section[];
  @Prop({ default: null }) readonly sectionId: number;
  @Prop({ default: 'SUBJECT' }) readonly contentType: ContentType;
  @Prop({ default: null }) readonly options: EdSectionOptions;
  @Prop({ default: true }) readonly hasControls: boolean;
  @Prop({ default: null }) readonly fixedSection: FixedSection;
  @Prop({ default: false }) readonly isProject: boolean;
  @Prop({ default: true }) readonly canPullSections: boolean;
  
  onAdd(minDate: string, isCreatingLesson = false) {
    this.$emit('onAddSection', minDate, isCreatingLesson);
  }

  get isEdition() {
    return this.mode === COURSE_MODE.EDIT;
  }

}